import { Container, ContainerModule, inject as inversifyInject } from 'inversify';
export class TypedContainer {
    container;
    constructor(container = new Container({ skipBaseClassChecks: true })) {
        this.container = container;
    }
    bind(key) {
        return this.container.bind(key);
    }
    createChild() {
        return new TypedContainer(this.container.createChild());
    }
    isBound(key) {
        return this.container.isBound(key);
    }
    get(key) {
        return this.container.get(key);
    }
    getNamed(key, named) {
        return this.container.getNamed(key, named);
    }
    getOptional(key) {
        if (this.isBound(key)) {
            return this.get(key);
        }
        return undefined;
    }
    // TODO: It would be great to type this such that the TypedCotnainerModule bindings are a subset of Bindings
    load(module) {
        this.container.load(module);
    }
}
export class TypedContainerModule extends ContainerModule {
    constructor(bindings) {
        super(bindings);
    }
}
export function injectFactory() {
    return (type) => inversifyInject(type);
}
//# sourceMappingURL=TypedContainer.js.map